import React from 'react';

import styled from 'styled-components';

import LoadingAnimation from 'components/loading-animation';

const LoadingContainer = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  margin: 0;
  width: 100%;
`;

export default function LoadingIndicator() {
  return (
    <LoadingContainer data-testid="store-locator-loading">
      <LoadingAnimation fillColor={Styles.color.primary} />
    </LoadingContainer>
  );
}
